const type = 'SET_CUSTOMER_PHONES_HISTORY_LOADING';

const setCustomerPhonesHistoryLoading = (data) => ({
  data,
  type,
});

export { type };
export default setCustomerPhonesHistoryLoading;
